













import { Component, Mixins } from "vue-mixin-decorator";
import { Prop } from "vue-property-decorator";
import CardDeckSetComponent, {
  DeckInfo
} from "@/app/basic/card/CardDeckSetComponent.vue";
import ComponentVue from "@/app/core/window/ComponentVue";
import CardComponent from "@/app/basic/card/CardComponent.vue";
import VueEvent from "@/app/core/decorator/VueEvent";

@Component({
  components: { CardDeckSetComponent, CardComponent }
})
export default class CardDeckChooserComponent extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: String, required: true })
  private title!: string;

  @Prop({ type: Array, required: true })
  private deckList!: DeckInfo[];

  // selectedDeckIdList
  @Prop({ type: Array, required: true })
  private selectedDeckIdList!: string[];

  @VueEvent
  private isSelectedDeck(cardDeckId: string): boolean {
    return this.selectedDeckIdList.findIndex(i => i === cardDeckId) > -1;
  }

  @VueEvent
  private onClickPresetDeck(cardDeckId: string) {
    const findIdx = this.selectedDeckIdList.findIndex(i => i === cardDeckId);
    if (findIdx === -1) {
      this.selectedDeckIdList.push(cardDeckId);
    } else {
      this.selectedDeckIdList.splice(findIdx, 1);
    }
  }
}
